import { useEffect } from 'react';
import { useSearchStore } from 'components/search/useSearchStore';
import { useIsPending } from 'customHooks/useIsPending';
import { useSearch } from 'customHooks/useSearch';

const useGlobalSearchResults = () => {
    const {
        query: rawQuery,
        resourceFilter: rawResourceFilter,
        setIsTypesensePending,
    } = useSearchStore();

    const [isPending, { query, resourceFilter }] = useIsPending({
        query: rawQuery,
        resourceFilter: rawResourceFilter,
    });

    const queryResults = useSearch({
        query,
        resourceFilter,
    });

    useEffect(() => {
        setIsTypesensePending(isPending);
    }, [isPending, setIsTypesensePending]);

    return queryResults;
};

export { useGlobalSearchResults };
